<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2"
>
  @if (fieldDef.meta?.value_hidden) {
    <ts-input
      [label]="fieldDef.label"
      [testId]="'form-field-' + fieldDef.name"
      [formControl]="redactedControl"
      [blurred]="true"
    />
  } @else {
    <ts-input
      [label]="fieldDef.label"
      [testId]="'form-field-' + fieldDef.name"
      [formControl]="control"
      (click)="edit()"
      (focusin)="edit()"
      (keyup.enter)="onBlur()"
      (blur)="onBlur()"
    />
  }
</div>
